module.exports = __webpack_public_path__ + "img/followers.9ab1378.svg";